export const MASSIVE_N4_GRAMMAR = [
    {
        pattern: "〜（さ）せられる",
        meaning: "Causative-Passive / Made to do",
        bn: "করতে বাধ্য হওয়া",
        explanation: "Indicates being forced to do something against one's will.",
        examples: [
            { jp: "お母さんに野菜を食べさせられました。", romaji: "Okaasan ni yasai o tabesaseraremashita.", en: "I was made to eat vegetables by my mother." }
        ]
    },
    {
        pattern: "〜（ら）れる",
        meaning: "Passive voice",
        bn: "কর্মবাচ্য",
        explanation: "The subject is the recipient of the action.",
        examples: [
            { jp: "泥棒に財布を盗まれました。", romaji: "Dorobou ni saifu o nusumaremashita.", en: "I had my wallet stolen by a thief." }
        ]
    },
    {
        pattern: "〜（さ）せる",
        meaning: "Causative / Make/Let someone do",
        bn: "কাউকে দিয়ে কিছু করানো",
        explanation: "Indicates making or letting someone do an action.",
        examples: [
            { jp: "先生が学生に宿題をさせました。", romaji: "Sensei ga gakusei ni shukudai o sasemashita.", en: "The teacher made the students do homework." }
        ]
    },
    {
        pattern: "〜てあげる / 〜てくれる / 〜てもらう",
        meaning: "Giving and Receiving favors",
        bn: "উপকার দেওয়া এবং নেওয়া",
        explanation: "Expressing actions done for the benefit of someone else.",
        examples: [
            { jp: "友達に本を貸してあげました。", romaji: "Tomodachi ni hon o kashite agemashita.", en: "I lent a book to my friend." },
            { jp: "田中さんが漢字を教えてくれました。", romaji: "Tanaka-san ga kanji o oshiete kuremashita.", en: "Tanaka-san taught me kanji." }
        ]
    },
    {
        pattern: "〜てみます",
        meaning: "Try doing something",
        bn: "চেষ্টা করে দেখা",
        explanation: "Doing an action to see what it's like.",
        examples: [
            { jp: "この靴を履いてみます。", romaji: "Kono kutsu o haite mimasu.", en: "I'll try on these shoes." },
            { jp: "日本語で話してみます。", romaji: "Nihongo de hanashite mimasu.", en: "I'll try speaking in Japanese." }
        ]
    },
    {
        pattern: "〜そうです (Hear-say)",
        meaning: "I heard that...",
        bn: "শুনলাম যে...",
        explanation: "Reporting information heard from another source.",
        examples: [
            { jp: "天気予報によると、明日は雨だそうです。", romaji: "Tenkiyohou ni yoru to, ashita wa ame da sou desu.", en: "According to the weather forecast, I heard it will rain tomorrow." }
        ]
    },
    {
        pattern: "〜という",
        meaning: "Called / Named",
        bn: "নামক / নামে পরিচিত",
        explanation: "Commonly used to identify people or things by name.",
        examples: [
            { jp: "「千と千尋の神隠し」という映画。", romaji: "'Sen to Chihiro no Kamikakushi' to iu eiga.", en: "A movie called 'Spirited Away'." }
        ]
    },
    {
        pattern: "〜はずです",
        meaning: "Should be / Expected to be",
        bn: "হওয়ার কথা",
        explanation: "Expressing a strong expectation based on logic.",
        examples: [
            { jp: "彼は今日来るはずです。", romaji: "Kare wa kyou kuru hazu desu.", en: "He should be coming today." }
        ]
    },
    {
        pattern: "〜たら",
        meaning: "If / When",
        bn: "যদি / যখন",
        explanation: "Conditional 'if' or temporal 'when'.",
        examples: [
            { jp: "安かったら買います。", romaji: "Yasukattara kaimasu.", en: "If it's cheap, I'll buy it." },
            { jp: "日本へ行ったら、富士山を見たいです。", romaji: "Nihon e ittara, Fujisan o mitai desu.", en: "When I go to Japan, I want to see Mt. Fuji." }
        ]
    },
    {
        pattern: "〜なら",
        meaning: "If it's the case that...",
        bn: "যদি এমনটা হয় তবে...",
        explanation: "Focuses on a topic brought up by someone else.",
        examples: [
            { jp: "明日なら暇ですよ。", romaji: "Ashita nara hima desu yo.", en: "If it's tomorrow, I'm free." }
        ]
    },
    {
        pattern: "〜が〜し、〜し",
        meaning: "Not only... but also...",
        bn: "শুধুমাত্র এটাই না, ওটাও...",
        explanation: "Listing reasons or descriptions.",
        examples: [
            { jp: "ここは安いし、美味しいし、いいレストランです。", romaji: "Koko wa yasui shi, oishii shi, ii resutoran desu.", en: "This place is cheap, delicious, and a good restaurant." }
        ]
    },
    {
        pattern: "〜ようです",
        meaning: "Seems like / Looks like",
        bn: "মনে হচ্ছে / দেখে মনে হচ্ছে",
        explanation: "Expressing similarity or conjecture based on appearance.",
        examples: [
            { jp: "今日は雨が降るようです。", romaji: "Kyou wa ame ga furu you desu.", en: "It seems like it will rain today." }
        ]
    },
    {
        pattern: "〜やすい / 〜にくい",
        meaning: "Easy to / Difficult to",
        bn: "সহজ / কঠিন",
        explanation: "Attached to verb stems to describe the ease of an action.",
        examples: [
            { jp: "このペンは書きやすいです。", romaji: "Kono pen wa kakiyasui desu.", en: "This pen is easy to write with." },
            { jp: "この道は歩きにくいです。", romaji: "Kono michi wa arukinikui desu.", en: "This road is difficult to walk on." }
        ]
    }
];
